import type { ThemeMode } from './palettes'

export const THEME_STORAGE_KEY = 'atwork-theme'

export function readThemeMode(storage: Pick<Storage, 'getItem'>): ThemeMode {
  try {
    return storage.getItem(THEME_STORAGE_KEY) === 'dark' ? 'dark' : 'light'
  } catch {
    return 'light'
  }
}

export function writeThemeMode(storage: Pick<Storage, 'setItem'>, mode: ThemeMode): void {
  try {
    storage.setItem(THEME_STORAGE_KEY, mode)
  } catch {
    // 浏览器禁用存储时仍允许本次会话切换主题。
  }
}
